import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './providers/AuthProvider';
import { NotificationProvider } from './providers/NotificationProvider';
import { AppRouter } from './router/AppRouter';
import './styles/globals.css';

const App: React.FC = () => {
	return (
		<BrowserRouter>
			<NotificationProvider>
				<AuthProvider>
					<AppRouter />
				</AuthProvider>
			</NotificationProvider>
		</BrowserRouter>
	);
};

export default App;
